import { render, staticRenderFns } from "./ManageBilling.vue?vue&type=template&id=56825b42&scoped=true"
import script from "./ManageBilling.vue?vue&type=script&lang=js"
export * from "./ManageBilling.vue?vue&type=script&lang=js"
import style0 from "./ManageBilling.vue?vue&type=style&index=0&id=56825b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56825b42",
  null
  
)

export default component.exports